module.exports = __webpack_public_path__ + "static/media/kop_surat.7e670659.png";